<list-view *ngIf="listePrestations" [liste]="listePrestations"></list-view>
